import ConfidentMessage from './ConfidentMessage';

export default ConfidentMessage;
